import get from 'lodash/get';
import { useState, useEffect } from 'react';

import BusinessHoursReference from 'src/models/BusinessHours/BusinessHoursReference';
import businessHoursReferencesResource from 'src/actions/businessHours/businessHoursReferencesResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import { STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';

const useBusinessHoursReferences = ({ item }) => {
  const { id } = item;
  const [references, setReferences] = useState<BusinessHoursReference[]>([]);

  const { value: referencesDto, loadingState: referencesLoadingState } = useDocumentResource(
    businessHoursReferencesResource,
    { fetch: true, params: { id } }
  );

  useEffect(() => {
    if (referencesLoadingState === STATUS_SUCCEEDED) {
      setReferences(get(referencesDto, id));
    }
  }, [id, referencesDto, referencesLoadingState, setReferences]);

  return { references };
};

export default useBusinessHoursReferences;
